module.exports = __webpack_public_path__ + "media/images/header-pdf-545233071b3905528f08347bfdc68aa4.png";